import styled from 'styled-components'

const HiddenSM = styled.div`${props => `
  display: none;
  text-decoration: underline;
  ${props.theme.media.sm(`
    margin-left: 4px;
    display: inline-block;
  `)}
`}`

HiddenSM.defaultProps = {
  theme: {
    media: {
      sm: (s) => s
    }
  }
}

export {
  HiddenSM
}